import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faUser, faTrashAlt, faLock, faSignOutAlt, faCog, faUsers, faEllipsisV, faBuilding, faThumbsUp, faThumbsDown, faConciergeBell, faStopwatch, faExclamationTriangle, faUserTie, faPlus, faBox, faCheck, faTimes, faStar, faCalendarAlt, faStream
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUser, faLock, faTrashAlt, faSignOutAlt, faCog, faUsers, faEllipsisV, faBuilding, faThumbsUp, faThumbsDown, faConciergeBell, faStopwatch, faExclamationTriangle, faUserTie, faPlus, faBox, faCheck, faTimes, faStar, faCalendarAlt, faStream
)

Vue.component('fa', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/js/plugins/fontawesome.js